import type { IStringifyOptions } from 'qs'
import qs from 'qs'

const options: IStringifyOptions = {
	skipNulls: true,
	arrayFormat: 'repeat',
	indices: false,
	encodeValuesOnly: true,
}

export const _stringify = (obj: Record<string, unknown>) => {
	return qs.stringify(obj, options)
}

export { _stringify as stringify }
